import { Risk } from 'api/queries/getRiskRegister.query';

import classes from 'components/widgets/RiskRegister/components/DurationVarianceCell/DurationVarianceCell.module.scss';

export const DurationVarianceCell = ({ value, unit }: { value: Risk['durationVariance']; unit: string }) => {
    const { min, likely, max } = value;
    return (
        <div className={classes.durationVarianceCell}>
            <div>
                <div className={classes.title}>Min</div>
                <div>
                    {min} {unit}
                </div>
            </div>
            {likely !== null && (
                <div>
                    <div className={classes.title}>Likely</div>
                    <div>
                        {likely} {unit}
                    </div>
                </div>
            )}
            <div>
                <div className={classes.title}>Max</div>
                <div>
                    {max} {unit}
                </div>
            </div>
        </div>
    );
};
